import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/home/ec2-user/tamdaone/tamdamedia/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow-left-swiper.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow-outside.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow-right-swiper.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/arrow.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/author.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/avatar-default.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/bg-latest-news.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/brand-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/close-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/edit-pencil.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/empty-img.jpg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/facebook-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/facebook-sidebar.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/homepage-gray-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/homepage-red-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/hot-news-gray-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/hot-news-red-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-calendar-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-cart.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-job-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-location-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-mail.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-phone.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-Quote.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/icon-salary-career.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/image-empty.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/lang-tdg-vn.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/location.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-cs.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-en.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-tamdacms.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-tdg-mobile.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-tdg.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logo-vi.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/logocms.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/menu-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/phone-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/play-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/search-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/sub-menu-logo.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/tamda-media-logo.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/tamda-wing.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/twitter_icon.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/video-gray-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/video-red-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/widgets-card.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/widgets-register-mail.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube-icon.svg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube-logo.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube-sidebar.webp");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/public/images/youtube.png");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/components/page-render.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/tamdaone/tamdamedia/src/stores/use-domain-store.ts");
